import { Injectable, inject } from '@angular/core';

import { mergeMap } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { CategoriesService } from '@rocksoft/osupdates-sdk';
import { safeMap } from '../effects.helpers';
import {
  CategoryAllowedOsUpdatesResolverActions,
  CurrentLocationViewActions,
  LocationAllowedOsUpdatesApiActions,
} from './location-allowed-os-updates.actions';

@Injectable()
export class LocationAllowedOsUpdateEffects {
  private readonly actions = inject(Actions);
  private readonly categoriesService = inject(CategoriesService);

  /**
   * (Re)Load the allowed OS updates for the category.
   * Effect: we load the state from the API.
   */
  AllowedOsUpdatesRequestedEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CategoryAllowedOsUpdatesResolverActions.requested, LocationAllowedOsUpdatesApiActions.updated),
      mergeMap(({ categoryId }) =>
        safeMap(
          this.categoriesService.getAllowedOsUpdatesForCategory({ categoryId: categoryId }),
          (updates) => {
            return LocationAllowedOsUpdatesApiActions.loaded({
              categoryAllowedOsUpdates: updates.map((update) => {
                return {
                  ...update,
                  categoryId,
                };
              }),
            });
          },
          (error) => LocationAllowedOsUpdatesApiActions.loadedError({ error })
        )
      )
    );
  });

  /**
   * Update/save the subset of possible OS updates as allowed for the category.
   * Effect: we update the sub set of allowed OS updates to the API.
   */
  UpdateLocationAllowedOsUpdateEffect$ = createEffect(() => {
    return this.actions.pipe(
      ofType(CurrentLocationViewActions.update),
      mergeMap(({ categoryId, categoryAllowedOsUpdates }) =>
        safeMap(
          this.categoriesService.updateAllowedOsUpdatesForCategory({
            categoryId: categoryId,
            osUpdateKey: categoryAllowedOsUpdates.map((a) => ({ productKey: a.productKey, version: a.version })),
          }),
          () =>
            LocationAllowedOsUpdatesApiActions.updated({
              categoryId,
              categoryAllowedOsUpdates,
            }),
          (error) => LocationAllowedOsUpdatesApiActions.updatedError({ error })
        )
      )
    );
  });
}
